// extracted by mini-css-extract-plugin
export var lg = "60rem";
export var md = "48rem";
export var sm = "36rem";
export var xl = "72rem";
export var xs = "24rem";